module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('el-row', {
    staticClass: "margin-bottom"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Zoek op titel.."
    },
    model: {
      value: (_vm.filters[1].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[1], "value", $$v)
      },
      expression: "filters[1].value"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 12
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.filters[0].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[0], "value", $$v)
      },
      expression: "filters[0].value"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "true"
    }
  }, [_vm._v("Archief")])], 1)], 1)], 1), _vm._v(" "), _c('data-tables', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.promotions,
      "pagination-props": {
        pageSizes: [20, 40, 60]
      },
      "filters": _vm.filters
    }
  }, [_vm._l((_vm.titles), function(title) {
    return _c('el-table-column', {
      key: title.label,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "sortable": "custom",
        "width": title.width
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Preview",
      "min-width": "170px",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": ("https://www.samsung.com/nl/promo/promo/?id=" + (scope.row.id)),
            "target": "_blank"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("STAGING")])], 1), _vm._v(" "), _c('a', {
          attrs: {
            "href": ("https://qaweb.samsung.com/nl/promo/promo/?id=" + (scope.row.id)),
            "target": "_blank"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("LIVE")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Actions",
      "min-width": "100px",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.staticUrl !== false) ? _c('div', [_c('el-tag', {
          attrs: {
            "size": "medium"
          }
        }, [_vm._v("STATIC URL")])], 1) : _vm._e(), _vm._v(" "), (scope.row.created === true) ? _c('div', [_c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              _vm.handleDelete(scope.$index, scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (scope.row.created === false) ? _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.staticUrl === false),
            expression: "scope.row.staticUrl === false"
          }]
        }, [_c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "el-icon-circle-plus"
          },
          on: {
            "click": function($event) {
              _vm.handleEdit(scope.$index, scope.row)
            }
          }
        })], 1) : _vm._e()]
      }
    }])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fdf881c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 214
// module chunks = 1